<template>
  <div ref="alertModal" aria-hidden="true" aria-labelledby="alertModal" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title textStyle">{{ $tc("registration.alert.title", 2) }}</h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <FormCollapseAlertComponent
            v-for="(alert, index) in alerts"
            :key="index"
            :index="index"
            :alert="alert"
            :name="name"
            :alertLength="alerts.length"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import FormCollapseAlertComponent from "@/components/form/alert/FormCollapseAlertComponent.vue";

export default {
  name: "FormAlertsModalComponent",
  components: { FormCollapseAlertComponent },
  props: {
    opened: {
      type: Boolean,
      required: true,
    },
    alerts: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  watch: {
    opened() {
      const container = this.$refs.alertModal;
      const modal = new Modal(container);
      if (this.opened) {
        modal.show();
      } else {
        modal.hide();
        this.$emit("hidden");
      }
    },
  },
  mounted() {
    this.$refs.alertModal.addEventListener("hidden.bs.modal", this.hidden);
  },
  methods: {
    hidden() {
      this.$emit("hidden");
      const container = this.$refs.alertModal;
      container.removeEventListener("click", this.stop);
    },

    stop(e) {
      e.stopPropagation();
    },
  },
};
</script>

<style scoped lang="scss"></style>
